export default __webpack_public_path__ + "static/media/login_bg_diet.f4b7e857.jpg";